import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookPaymentServiceService } from '../../shared/services/apis/platform/book-payment-service.service';
import { BookPaymentCartResponse } from '../../shared/services/responses/platform/book-payment-cart.response';
import { AlertService, AlertType } from '../../shared/services/alert.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { LoginValidationComponent } from '../login-validation.component/login-validation.component';
import { MenuComponent } from '../../shared/components/menu/menu.component';
import { UserCreditCardService } from '../../shared/services/apis/platform/user-credit-card.service';
import { UserCreditCardStruct } from '../../shared/services/responses/platform/user-credit-card.response';
import { PaymentMethodsStruct, PaymentMethodInstallmentStruct } from '../../shared/services/responses/platform/payment-methods.response';
import { PaymentMethodsService } from '../../shared/services/apis/platform/payment-methods.service';
import { BookPaymentRequest } from '../../shared/services/requests/platform/book-payment.request';
import { BookPaymentService } from '../../shared/services/apis/platform/book-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { WaitingPaymentDialogComponent } from '../book-payment-modal/book-payment-modal.component';
import { BookPaymentStatusEnum } from '../../shared/services/enums/book-payment-status.enum';
import { PaymentMethodEnum } from '../../shared/services/enums/payment-method.enum';
import { RedirectService } from '../../redirect-service';
import { StatusVersionEnum } from '../../shared/services/enums/status-version.enum';

@Component({
  selector: 'app-book-payment',
  templateUrl: './book-payment.component.html',
  styleUrls: ['./book-payment.component.css'],
  standalone: true,
  imports: [CommonModule,
    LoginValidationComponent,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MenuComponent,
    MatOptionModule,
    MatRadioModule,
    FooterComponent,
    MatButtonModule,
    MatSelectModule],
})
export class BookPaymentComponent implements OnInit {
  // Cart
  cart: BookPaymentCartResponse | null = null;
  isLoading = false;
  idBookVersion: number = 0;


  statusInterval: any = null;
  isWaitingPayment: boolean = false;

  // Métodos e parcelas
  paymentMethods: PaymentMethodsStruct[] = [];
  selectedPaymentMethod: number | null = null;
  paymentMethodInstallments: PaymentMethodInstallmentStruct[] = [];
  selectedPaymentMethodInstallment: number | null = null;

  // Cartões de crédito
  userCreditCards: UserCreditCardStruct[] = [];
  selectedCreditCardId: number | null = null;

  // Forms
  creditCardForm: FormGroup;
  billingAddressForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private paymentMethodsService: PaymentMethodsService,
    private userCreditCardService: UserCreditCardService,
    private bookPaymentServiceService: BookPaymentServiceService,
    private alertService: AlertService,
    private router: Router,
    private dialog: MatDialog,
    private bookPaymentService: BookPaymentService,
    private redirectService: RedirectService,
    private fb: FormBuilder
  ) {
    this.creditCardForm = this.fb.group({
      holderName: ['', Validators.required],
      number: ['', Validators.required],
      expiryMonth: ['', Validators.required],
      expiryYear: ['', Validators.required],
      ccv: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      cpfCnpj: ['', Validators.required],
      phone: [''],
      mobilePhone: ['', Validators.required],
      saveCreditCard: [true]
    });
    this.billingAddressForm = this.fb.group({
      postalCode: ['', Validators.required],
      address: ['', Validators.required],
      addressNumber: ['', Validators.required],
      addressComplement: [''],
      city: ['', Validators.required],
      state: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Pega idBookVersion da rota
    this.idBookVersion = Number(this.route.snapshot.paramMap.get('idBookVersion'));
    if (!this.idBookVersion) {
      this.alertService.show('Erro', 'Serviço não identificado.', AlertType.error);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Fluxo de login, busca cart, métodos e cartões juntos!
  onLoginValidated(isLogged: boolean) {
    if (!isLogged) return;
    this.isLoading = true;
    this.getByBookVersion();
    this.getPaymentMethods();
    this.getUserCreditCards();
  }

  monitorPaymentStatus(): void {
    // Evita múltiplos intervalos
    if (this.statusInterval) clearInterval(this.statusInterval);
    this.verifyModal();
    const checkStatus = () => {
      this.getByBookVersion();
    };


    this.statusInterval = setInterval(checkStatus, 10000); // 10 em 10 segundos
    checkStatus(); // Checa já na primeira chamada
  }

  verifyModal(): void {
    if (this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.Aprovado ||
      (this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.PagamentoEmCurso && this.cart?.idPaymentMethod === PaymentMethodEnum.CartaoRecorrente)) {
      this.closeWaitingPaymentModal();
      this.router.navigate(['/livro-detalhes', this.idBookVersion]);
      clearInterval(this.statusInterval);
    } else if (this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.Reprovado || this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.Cancelado) {
      this.closeWaitingPaymentModal();
      this.alertService.show('Pagamento reprovado', 'Tente novamente ou utilize outra forma de pagamento.', AlertType.error);
      clearInterval(this.statusInterval);
    }
    else if (this.cart == null || this.cart?.idBookPaymentStatus == null || this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.Carrinho) {
      this.closeWaitingPaymentModal();
      clearInterval(this.statusInterval);
    }
  }

  // Exibe modal de aguardando pagamento
  openWaitingPaymentModal(pixCopyPaste?: string | null | undefined, pixQRCode?: string | null | undefined): void {
    this.isWaitingPayment = true;
    this.dialog.open(WaitingPaymentDialogComponent, {
      disableClose: true,
      data: {
        title: 'Aguardando confirmaçao de pagamento',
        message: 'Assim que for confirmado o pagamento, você poderá continuar!',
        pixCopyPaste: pixCopyPaste,
        pixQRCode: pixQRCode
      }
    });
  }

  closeWaitingPaymentModal(): void {
    this.isWaitingPayment = false;
    this.dialog.closeAll();
  }

  getByBookVersion(): void {
    this.bookPaymentServiceService.getByBookVersion(this.idBookVersion).subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro ao carregar carrinho', res.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.cart = res;

        // if (res.isCreditReviewing && res.idStatusVersion === StatusVersionEnum.AguardandoPagamento) {
        //   this.router.navigate(['/livro-detalhes', this.idBookVersion]);
        // }

        // o controle de status na tela de pagamento não pode ocorrer atraves do redirecionador 
        this.redirectService.redirectByStatus(res.idStatusVersion as number, this.idBookVersion as number, res.isCreditReviewing, res.idBookPaymentStatus === BookPaymentStatusEnum.Aprovado);

        // Após receber o carrinho, se métodos já carregados, sincroniza
        if (this.paymentMethods.length > 0) {
          this.setPaymentSelectionsFromCart();
        }

        // Lógica do modal permanece igual
        if (this.cart?.idBookPaymentStatus === BookPaymentStatusEnum.AguardandoPagamento) {
          if (!this.isWaitingPayment) {
            this.openWaitingPaymentModal(this.cart?.pixCopyPaste, this.cart?.pixQRCode);
            this.monitorPaymentStatus();
          }
        }
        this.verifyModal();
        this.isLoading = false;
      },
      error: (err) => {
        this.alertService.show('Erro inesperado', err, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  get totalBookServiceValue(): number {
    return this.cart?.listService?.reduce((sum, item) => sum + (item.bookServiceValue || 0), 0) || 0;
  }

  private setPaymentSelectionsFromCart() {
    if (!this.cart) return;

    // Seleciona o método de pagamento, se houver
    if (this.cart.idPaymentMethod) {
      this.selectedPaymentMethod = this.cart.idPaymentMethod;
      const method = this.paymentMethods.find(m => m.idPaymentMethod === this.cart?.idPaymentMethod);
      this.paymentMethodInstallments = method?.listPaymentMethodInstallmentStruct || [];

      // Seleciona a parcela, se houver
      if (this.cart.idPaymentMethodInstallment) {
        this.selectedPaymentMethodInstallment = this.cart.idPaymentMethodInstallment;
      } else if (this.paymentMethodInstallments.length > 0) {
        this.selectedPaymentMethodInstallment = this.paymentMethodInstallments[0].idPaymentMethodInstallment;
      }
    }
  }

  getPaymentMethods(): void {
    this.paymentMethodsService.getAuthorPaymentMethods().subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro ao buscar métodos de pagamento', res.errorDescription, AlertType.error);
          return;
        }
        this.paymentMethods = res.listPaymentMethodsStruct || [];
        // Pré-seleciona id=1 se existir, senão o primeiro
        const defaultMethod = this.paymentMethods.find(m => m.idPaymentMethod === 1)
          || this.paymentMethods[0];
        if (defaultMethod) {
          this.selectedPaymentMethod = defaultMethod.idPaymentMethod;
          this.paymentMethodInstallments = defaultMethod.listPaymentMethodInstallmentStruct || [];
          if (this.paymentMethodInstallments.length > 0) {
            this.selectedPaymentMethodInstallment = this.paymentMethodInstallments[0].idPaymentMethodInstallment;
          }
        }
      },
      error: (err) => {
        this.alertService.show('Erro inesperado ao buscar métodos de pagamento', err, AlertType.error);
      }
    });
  }

  onPaymentMethodChange(idPaymentMethod: number) {
    this.selectedPaymentMethod = idPaymentMethod;
    const found = this.paymentMethods.find(m => m.idPaymentMethod === idPaymentMethod);
    this.paymentMethodInstallments = found?.listPaymentMethodInstallmentStruct || [];
    if (this.paymentMethodInstallments.length > 0) {
      this.selectedPaymentMethodInstallment = this.paymentMethodInstallments[0].idPaymentMethodInstallment;
    } else {
      this.selectedPaymentMethodInstallment = null;
    }
  }

  getInstallmentLabel(installment: PaymentMethodInstallmentStruct): string {
    const total = this.totalBookServiceValue;
    const count = installment.installmentCount;
    const interest = installment.installmentInterest;
    let parcela = 0;
    let totalComJuros = 0;

    if (interest > 0 && count > 1) {
      // Fórmula Price (juros compostos)
      const i = interest / 100;
      const n = count;
      parcela = (total * i) / (1 - Math.pow(1 + i, -n));
      totalComJuros = parcela * n;
      return `${count}x de R$ ${parcela.toFixed(2)} (total R$ ${totalComJuros.toFixed(2)}) - ${interest}% am.`;
    } else {
      parcela = total / count;
      totalComJuros = parcela * count;
      return `${count}x de R$ ${parcela.toFixed(2)} (total R$ ${totalComJuros.toFixed(2)}) - sem juros`;
    }
  }


  getUserCreditCards(): void {
    this.userCreditCardService.getUserCreditCards().subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro ao buscar cartões', res.errorDescription, AlertType.error);
          return;
        }
        this.userCreditCards = res.listUserCreditCardStruct || [];
        // Pré-seleciona principal, senão o primeiro
        if (this.userCreditCards.length > 0) {
          const primary = this.userCreditCards.find(x => x.isPrimaryCard);
          this.selectedCreditCardId = primary
            ? primary.idUserCreditCard
            : this.userCreditCards[0].idUserCreditCard;
        } else {
          this.selectedCreditCardId = null;
        }
      },
      error: (err) => {
        this.alertService.show('Erro inesperado ao buscar cartões', err, AlertType.error);
      }
    });
  }

  get isCreditCardFlow(): boolean {
    // Cartão de crédito são os métodos id 1 ou 2
    return this.selectedPaymentMethod === 1 || this.selectedPaymentMethod === 2;
  }

  get showNewCreditCardForm(): boolean {
    return this.isCreditCardFlow &&
      (this.selectedCreditCardId === null || this.userCreditCards.length === 0);
  }

  // Monta o request e envia ao backend
  onSubmit() {
    if (!this.selectedPaymentMethod || !this.selectedPaymentMethodInstallment) {
      this.alertService.show('Selecione método e parcelamento', '', AlertType.error);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.isLoading = true;

    if (this.isCreditCardFlow) {
      if (this.showNewCreditCardForm) {
        if (this.creditCardForm.invalid || this.billingAddressForm.invalid) {
          this.alertService.show('Preencha todos os campos obrigatórios do cartão e endereço.', '', AlertType.error);
          return;
        }
      }
    }

    const req: BookPaymentRequest = {
      idBookVersion: this.idBookVersion,
      idPaymentMethodInstallment: this.selectedPaymentMethodInstallment,
      idUserCreditCard: this.showNewCreditCardForm ? undefined : this.selectedCreditCardId,
      userCreditCard: this.showNewCreditCardForm ? {
        holderName: this.creditCardForm.value.holderName,
        number: this.creditCardForm.value.number,
        expiryMonth: this.creditCardForm.value.expiryMonth,
        expiryYear: this.creditCardForm.value.expiryYear,
        ccv: this.creditCardForm.value.ccv,
        name: this.creditCardForm.value.holderName,
        email: this.creditCardForm.value.email,
        cpfCnpj: this.creditCardForm.value.cpfCnpj,
        postalCode: this.billingAddressForm.value.postalCode,
        addressNumber: this.billingAddressForm.value.addressNumber,
        addressComplement: this.billingAddressForm.value.addressComplement,
        phone: this.creditCardForm.value.phone,
        mobilePhone: this.creditCardForm.value.mobilePhone,
        saveCreditCard: this.creditCardForm.value.saveCreditCard,
        remoteIp: '', // pode setar aqui se quiser capturar ip real
      } : undefined
    };

    this.isLoading = true;
    this.bookPaymentService.postPayment(req).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Falha no pagamento', res.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Pedido criado com sucesso', '', AlertType.success);
        this.openWaitingPaymentModal(res.pixCopyPaste, res.pixQRCode);
        this.monitorPaymentStatus();
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', err, AlertType.error);
        this.isLoading = false;
      }
    });
  }
}
